export default "__VITE_ASSET__CvdcL6Ed__"